<!-- App.svelte -->
<script>
  import { Router, Link, Route } from "svelte-routing";
  import Home from "./pages/home.svelte";
  import Shop from "./pages/shop.svelte";
  import Product from "./pages/product.svelte";
  import NotFound from "./pages/notFound.svelte";
  import Settings from "./pages/settings.svelte";
  import Login from "./pages/Login.svelte";
  import Fp from "./pages/fp.svelte";
  import Changepass from "./pages/changepass.svelte";
  import Createaccount from "./pages/createaccount.svelte";
  import Wishlist from "./pages/wishlist.svelte";
  import Profilesettings from "./pages/profilesettings.svelte";
  import Cart from "./pages/cart.svelte";
  import Checkout from "./pages/checkout.svelte";
  import Orders from "./pages/orders.svelte";
  import OrderDetails from "./pages/order_details.svelte";
  import Filter from "./pages/filter.svelte";
  import FailedPayments from "./pages/failed_payments.svelte";
  import FailedPaymentDetails from "./pages/failed_payment_details.svelte";
  import ReturnAndExchangePolicy from "./pages/return_and_exchange_policy.svelte";
  import PrivacyPolicy from "./pages/privacy_policy.svelte";
  import ShippingPolicy from "./pages/shipping_policy.svelte";
  import TermsAndConditions from "./pages/terms_and_conditions.svelte";
  import { onMount } from "svelte";
  import AvailableCoupons from "./pages/available-coupons.svelte";
  export let url = ""; //mandatory

  onMount(() => {
    let mediaQueryObj = window.matchMedia("(prefers-color-scheme: dark)");
    let isDarkMode = mediaQueryObj.matches; //

    if (isDarkMode === true) {
      document.body.classList.remove("theme-light", "theme-dark");
      document.body.classList.add(`theme-dark`);
    }

    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", function (e) {
        const colorScheme = e.matches ? "dark" : "light";
        console.log(colorScheme);

        if (colorScheme === "dark") {
          document.body.classList.remove("theme-light", "theme-dark");
          document.body.classList.add(`theme-dark`);
        } else {
          document.body.classList.remove("theme-light", "theme-dark");
          document.body.classList.add(`theme-light`);
        }
      });

    var loader = document.getElementById("preloader");
    window.addEventListener("load", function () {
      loader.style.display = "none";
    });
  });

</script>

<Router {url}>
  <div id="preloader" />
  <!-- <div id="preloader" class="loader">
    <svg viewBox="0 0 80 80">
      <rect x="8" y="8" width="64" height="64" />
    </svg>
  </div> -->
  <div>
    <!-- Home Page -->
    <Route path="/"><Home /></Route>
    <!-- Shop Page -->
    <Route path="/shop"><Shop /></Route>
    <!-- Shop sub Pages -->
    <Route path="shop/:id"><Shop /></Route>
    <!-- Shop Page -->
    <Route path="/shop/filter"><Filter /></Route>
    <!-- Shop filter sub Pages -->
    <Route path="/shop/filter/:id"><Filter /></Route>
    <!-- Single Product Page -->
    <Route path="/product"><Product /></Route>
    <!-- Wishlist Page -->
    <Route path="/wishlist"><Wishlist /></Route>
    <!-- product sub Pages -->
    <Route path="/product/:id"><Product /></Route>
    <!-- Settings Page -->
    <Route path="/settings"><Settings /></Route>
    <!-- Login Page -->
    <Route path="/login"><Login /></Route>
    <!-- Login Page -->
    <Route path="/fp"><Fp /></Route>
    <!-- Get otp Page -->
    <Route path="/changepass"><Changepass /></Route>
    <!-- Account Create Page -->
    <Route path="/register"><Createaccount /></Route>
    <!-- Profile Sttings Page -->
    <Route path="/profile-settings"><Profilesettings /></Route>
    <!-- Cart Page -->
    <Route path="/cart"><Cart /></Route>
    <!-- Cart Page -->
    <Route path="/checkout"><Checkout /></Route>
    <!-- Orders Page -->
    <Route path="/orders"><Orders /></Route>
    <!-- Orders Page -->
    <Route path="/order_details"><OrderDetails /></Route>
    <!-- Available Coupons Page -->
    <Route path="//available-coupons"><AvailableCoupons /></Route>
    <!-- FailedPaymentDetails Page -->
    <Route path="/failedpayments"><FailedPayments /></Route>
    <!-- FailedPaymentDetails sub Page -->
    <Route path="/failedpayments/:id"><FailedPaymentDetails /></Route>
    <!-- Not Found Page -->
    <Route><NotFound /></Route>
    <!-- Return and Exchange Policy Page -->
    <Route path="/return_and_exchange_policy"><ReturnAndExchangePolicy /></Route
    >
    <!-- Privacy Policy Page -->
    <Route path="/privacy_policy"><PrivacyPolicy /></Route>
    <!-- Shipping Policy Page -->
    <Route path="/shipping_policy"><ShippingPolicy /></Route>
    <!-- Terms and conditions Page -->
    <Route path="/terms_and_conditions"><TermsAndConditions /></Route>
  </div>
</Router>
